module.exports = __webpack_public_path__ + "static/media/derek.a163f412.jpeg";